/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.Charts {
    angular.module('meevo.plugins.charts', []);
}
